module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Medium.d20db9b.eot";